
class MindResourceData {
    constructor() {
        this.url = "";
        this.mindId = "";
        this.nodeIds = [];
    }
}
export default MindResourceData